import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import Footer from "../Components/footer";
import  Header  from "../Components/header";
import SideBar from "../Components/sidebar";
import Button from "../Components/button";
import DataTable from "../Components/datatablefeedback";
import { RedirectNotLogin, RedirectContractor, AlertMessageOut, getSession } from "../Components/function";

class Feedback extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      userID : '',
      scriptID: '',
      file: '',
      message: '',
    }
    }
    
    componentDidMount(){
      RedirectNotLogin();
      RedirectContractor();
    }

    componentDidUpdate() {
      RedirectNotLogin();
      RedirectContractor();
    }
 
  render(){
    return (
        <div className="App AppWrap">
    
    <Header self={this}/>
    

    <div className="App iBG dash-dash-full">
    <div className="containers">
   
    <div className="card-lt-wrap ml0">
    <div className="card-lt breadcrumb">
  <h1><NavLink to="/dashboard">Dashboard</NavLink> <i className="fa fa-chevron-right"></i> Feedbacks</h1>
  </div>
  </div>

  <div className="card-lt-wrap ml0">
    <div className="card-lt">
     
     {AlertMessageOut(this)}

     <DataTable
     route="feedback"
     badge={['', '', '', '', '']}
     thclassX={['', '', '', 'nowrap', 'nowrap', 'nowrap']}
     th={
        ['Script ID', 'Geo Target', 'Review 1', 'Review 2', 'Review 3']
     }
     td={
        ['scriptID', 'target', 'cmd1', 'cmd2', 'cmd3']
    }
     cmd="feedback"
     self={this}
     />

    
     </div>

        <Footer classX="dash-footer"/>

    </div>
    
    </div>

    </div>

    </div>
    );
}

}

export default Feedback;